// CompassionateApproachSection.js
import React from "react";
import { Phone } from "lucide-react";
import approachImage from "../assets/compassionate-approach-image.jpg";

const CompassionateApproachSection = () => {
  return (
    <section className="py-16 px-6 md:px-12 lg:px-24 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-6 leading-tight">
              A Compassionate Approach to Dementia Care
            </h2>

            <div className="space-y-4 text-gray-700 font-light leading-relaxed mb-8">
              <p>
                Changes in mood, memory, and thinking can be some of the most
                challenging aspects of aging. While Alzheimer's is the most
                recognized, there are many forms of cognitive decline and{" "}
                <span className="text-[#E85D2C] font-normal">dementia</span>{" "}
                that affect individuals in different ways—all of them
                emotionally complex and demanding for families.
              </p>

              <p>
                Caring for a loved one with cognitive challenges can be
                overwhelming, especially if you're doing it on your own. It's
                not just the condition—it's the emotional toll, the uncertainty,
                and the heartbreaking moments when nothing seems to help. Even
                with your best efforts, it can feel like you're constantly
                falling short.
              </p>

              <p>
                At Allawah Lodge, we're here to remind you that you don't have
                to carry it all alone. Our care approach focuses on creating
                meaningful moments—helping you shift from constant worry to
                celebrating the good days together.
              </p>
            </div>

            <a
              href="tel:+61269272706"
              className="inline-flex items-center gap-2 bg-[#E85D2C] hover:bg-[#d54d1f] text-white font-medium px-6 py-3 rounded-full transition-colors"
            >
              <Phone size={20} />
              CALL: (02) 6927 2706
            </a>
          </div>

          {/* Right Image */}
          <div>
            <img
              src={approachImage}
              alt="Caregiver with elderly woman"
              className="w-full h-auto rounded-2xl shadow-lg object-cover"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default CompassionateApproachSection;
